import { apiFetch } from './auth-service';
import { EnrollmentDoc } from './enrollment-service';
import { QuizAttempt } from './quiz-attempt-service';

export interface GeneratedQuestion {
  type: 'mcq' | 'true_false';
  question: string;
  options: string[];
}

export interface GeneratedQuizDoc {
  generated: boolean;
  questions?: GeneratedQuestion[];
  questionCount?: number;
}

export interface SubmitResult {
  score: number;
  correct: number;
  total: number;
  passed: boolean;
  passingScore: number;
  attempt: QuizAttempt;
  enrollment: EnrollmentDoc | null;
}

export const getGeneratedQuiz = async (
  courseId: string, moduleId: string, itemId: string
): Promise<GeneratedQuizDoc> => {
  return apiFetch.get(`/quiz-gen/${courseId}/${moduleId}/${itemId}`);
};

export const generateQuiz = async (
  courseId: string, moduleId: string, itemId: string
): Promise<GeneratedQuizDoc> => {
  return apiFetch.post(`/quiz-gen/${courseId}/${moduleId}/${itemId}`, {});
};

export const submitGeneratedQuiz = async (
  courseId: string, moduleId: string, itemId: string, answers: string[]
): Promise<SubmitResult> => {
  return apiFetch.post(`/quiz-gen/${courseId}/${moduleId}/${itemId}/submit`, { answers });
};
